import { useState } from "react";
import type { BudgetLimitErrorResponseV2 } from "../types";

export interface OverrideRequest<T> {
  errorData: BudgetLimitErrorResponseV2;
  retryArgs: T;
}

export function useOverrideState<T>() {
  const [pending, setPending] = useState<OverrideRequest<T> | null>(null);

  function request(errorData: BudgetLimitErrorResponseV2, retryArgs: T) {
    setPending({ errorData, retryArgs });
  }

  function clear() {
    setPending(null);
  }

  return { pending, request, clear };
}
